<div class="summary-wrap">
    <app-widget-header
        [headers]="headers"
        [dashboardId]="dashboardId"
        [widgetId]="id"
        [userPreferences]="userPreferences"
        [entitlements]="entitlements"
        [user]="user"
        (widgetSaved)="onWidgetSaved($event)"
        (settingsChanged)="onWidgetSettingOverridesChanged($event.updatedWidget, $event.changes)"
        (headerMenuSelect)="onHeaderMenuSelect($event)"
    >
    </app-widget-header>

    @if (summaryConfiguration && shouldDisplayVisualization()) {
        <div class="summary-content"
            [ngClass]="{
                    'small-padding': summaryConfiguration.textSize! < 20,
                    'medium-padding': summaryConfiguration.textSize! >= 20 && summaryConfiguration.textSize! < 30,
                    'large-padding': summaryConfiguration.textSize! >= 30
            }">

            <div class="content-spacer"></div>

            @if (summaryConfiguration) {
                <div class="content-list">
                    <ul>
                        @for (summary of summaryFields; let i = $index; track i) {
                            <li
                                    [ngClass]="{
                                        'border': summaryConfiguration.isLineSeparatorEnabled && i !== summaryFields.length-1,
                                        'redcolor': summary.isRed,
                                    }">
                                <h5
                                        class="summary-text"
                                        [style.font-size.px]="summaryConfiguration.textSize">
                                    {{ summary.columnValue }}
                                </h5>

                                <label class="summary-label">{{ summary.columnName }}</label>
                            </li>
                        }
                    </ul>
                </div>
            }
        </div>
    }

    @if (shouldDisplayMessage()) {
        <div class="no-data">
            <span>{{ getErrorMessage() }}</span>
        </div>
    }

    @if (isErrorOccurred && displayHIErrorMessage) {
        <div class="no-data hi-error">
            <span>{{ getHIErrorMessage() }}</span>
            <span>{{ getHIAdditionalMessage() }}</span>
        </div>
    }

    @if (isErrorOccurred && !displayHIErrorMessage) {
        <div class="no-data" [class.error]="isErrorOccurred">
            <span
                class="icon-notification-warning"
                (click)="showErrorMessage()">
            </span>
        </div>
    }
</div>

<ng-template #fastnessCheckTemplate>
    <div class="fastness-title">Date Not Cached.</div>
    <div class="fastness-message">Data for this date is not cached. Do you wish to continue?</div>
</ng-template>
